import React, { Component } from "react";
import * as LINK from "./../../constants/Links";

import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { Route, Switch, Link, Redirect } from "react-router-dom";

import * as Actions from "./../../actions/index";

class Index extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {

    };

  }
  // static getDerivedStateFromProps(nextProps, prevState)
  // {


  // }

  componentDidUpdate(prevProps, prevState)
  {


  }
  componentDidMount()
  {

  }
  render()
  {
    let { routers } = this.props;

    return (
      <div className="py-6 container">
        <div className="pb-6">
          <div className="ant-card ant-card-bordered">
            <div className="ant-card-body">
              <nav className="level">
                <div className="level-item has-text-centered">
                  <div>
                    <p className="heading">Total success this week</p>
                    <p className="title">16</p>
                  </div>
                </div>
                <div className="level-item has-text-centered">
                  <div>
                    <p className="heading">Total raised this week</p>
                    <p className="title">$988.3K</p>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
        <div className="ant-card ant-card-bordered">
          <div className="ant-card-body">
            <div className="ant-tabs ant-tabs-top">
              <div role="tablist" className="ant-tabs-nav">
                <div className="ant-tabs-nav-wrap ant-tabs-nav-wrap-ping-right">
                  <div className="ant-tabs-nav-list" style={{ transform: "translate(0px, 0px)" }}>
                    <div className="ant-tabs-tab ant-tabs-tab-active">
                      <div role="tab" aria-selected="true" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-0" aria-controls="rc-tabs-0-panel-0">Week 46/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-1" aria-controls="rc-tabs-0-panel-1">Week 45/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-2" aria-controls="rc-tabs-0-panel-2">Week 44/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-3" aria-controls="rc-tabs-0-panel-3">Week 43/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-4" aria-controls="rc-tabs-0-panel-4">Week 42/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-5" aria-controls="rc-tabs-0-panel-5">Week 41/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-6" aria-controls="rc-tabs-0-panel-6">Week 40/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-7" aria-controls="rc-tabs-0-panel-7">Week 39/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-8" aria-controls="rc-tabs-0-panel-8">Week 38/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-9" aria-controls="rc-tabs-0-panel-9">Week 37/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-10" aria-controls="rc-tabs-0-panel-10">Week 36/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-11" aria-controls="rc-tabs-0-panel-11">Week 35/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-12" aria-controls="rc-tabs-0-panel-12">Week 34/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-13" aria-controls="rc-tabs-0-panel-13">Week 33/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-14" aria-controls="rc-tabs-0-panel-14">Week 32/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-15" aria-controls="rc-tabs-0-panel-15">Week 31/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-16" aria-controls="rc-tabs-0-panel-16">Week 30/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-17" aria-controls="rc-tabs-0-panel-17">Week 29/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-18" aria-controls="rc-tabs-0-panel-18">Week 28/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-19" aria-controls="rc-tabs-0-panel-19">Week 27/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-20" aria-controls="rc-tabs-0-panel-20">Week 26/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-21" aria-controls="rc-tabs-0-panel-21">Week 25/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-22" aria-controls="rc-tabs-0-panel-22">Week 24/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-23" aria-controls="rc-tabs-0-panel-23">Week 23/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-24" aria-controls="rc-tabs-0-panel-24">Week 22/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-25" aria-controls="rc-tabs-0-panel-25">Week 21/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-26" aria-controls="rc-tabs-0-panel-26">Week 20/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-27" aria-controls="rc-tabs-0-panel-27">Week 19/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-28" aria-controls="rc-tabs-0-panel-28">Week 18/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-29" aria-controls="rc-tabs-0-panel-29">Week 17/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-30" aria-controls="rc-tabs-0-panel-30">Week 16/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-31" aria-controls="rc-tabs-0-panel-31">Week 15/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-32" aria-controls="rc-tabs-0-panel-32">Week 14/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-33" aria-controls="rc-tabs-0-panel-33">Week 13/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-34" aria-controls="rc-tabs-0-panel-34">Week 12/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-35" aria-controls="rc-tabs-0-panel-35">Week 11/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-36" aria-controls="rc-tabs-0-panel-36">Week 10/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-37" aria-controls="rc-tabs-0-panel-37">Week 9/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-38" aria-controls="rc-tabs-0-panel-38">Week 8/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-39" aria-controls="rc-tabs-0-panel-39">Week 7/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-40" aria-controls="rc-tabs-0-panel-40">Week 6/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-41" aria-controls="rc-tabs-0-panel-41">Week 5/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-42" aria-controls="rc-tabs-0-panel-42">Week 4/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-43" aria-controls="rc-tabs-0-panel-43">Week 3/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-44" aria-controls="rc-tabs-0-panel-44">Week 2/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-45" aria-controls="rc-tabs-0-panel-45">Week 1/2022</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-46" aria-controls="rc-tabs-0-panel-46">Week 52/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-47" aria-controls="rc-tabs-0-panel-47">Week 51/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-48" aria-controls="rc-tabs-0-panel-48">Week 50/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-49" aria-controls="rc-tabs-0-panel-49">Week 49/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-50" aria-controls="rc-tabs-0-panel-50">Week 48/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-51" aria-controls="rc-tabs-0-panel-51">Week 47/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-52" aria-controls="rc-tabs-0-panel-52">Week 46/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-53" aria-controls="rc-tabs-0-panel-53">Week 45/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-54" aria-controls="rc-tabs-0-panel-54">Week 44/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-55" aria-controls="rc-tabs-0-panel-55">Week 43/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-56" aria-controls="rc-tabs-0-panel-56">Week 42/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-57" aria-controls="rc-tabs-0-panel-57">Week 41/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-58" aria-controls="rc-tabs-0-panel-58">Week 40/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-59" aria-controls="rc-tabs-0-panel-59">Week 39/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-60" aria-controls="rc-tabs-0-panel-60">Week 38/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-61" aria-controls="rc-tabs-0-panel-61">Week 37/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-62" aria-controls="rc-tabs-0-panel-62">Week 36/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-63" aria-controls="rc-tabs-0-panel-63">Week 35/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-64" aria-controls="rc-tabs-0-panel-64">Week 34/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-65" aria-controls="rc-tabs-0-panel-65">Week 33/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-66" aria-controls="rc-tabs-0-panel-66">Week 32/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-67" aria-controls="rc-tabs-0-panel-67">Week 31/2021</div>
                    </div>
                    <div className="ant-tabs-tab">
                      <div role="tab" aria-selected="false" className="ant-tabs-tab-btn" tabindex="0" id="rc-tabs-0-tab-68" aria-controls="rc-tabs-0-panel-68">Week 30/2021</div>
                    </div>
                    <div className="ant-tabs-ink-bar ant-tabs-ink-bar-animated" style={{ left: "0px", width: "89px" }}></div>
                  </div>
                </div>
                <div className="ant-tabs-nav-operations"><button type="button" className="ant-tabs-nav-more" tabindex="-1" aria-hidden="true" aria-haspopup="listbox" aria-controls="rc-tabs-0-more-popup" id="rc-tabs-0-more" aria-expanded="false"><span role="img"
                  aria-label="ellipsis" className="anticon anticon-ellipsis"><svg
                    viewBox="64 64 896 896" focusable="false" data-icon="ellipsis"
                    width="1em" height="1em" fill="currentColor" aria-hidden="true">
                    <path
                      d="M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z">
                    </path>
                  </svg></span></button></div>
              </div>
              <div className="ant-tabs-content-holder">
                <div className="ant-tabs-content ant-tabs-content-top">
                  <div role="tabpanel" tabindex="0" aria-hidden="false" className="ant-tabs-tabpane ant-tabs-tabpane-active" id="rc-tabs-0-panel-0" aria-labelledby="rc-tabs-0-tab-0"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-1" aria-labelledby="rc-tabs-0-tab-1"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-2" aria-labelledby="rc-tabs-0-tab-2"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-3" aria-labelledby="rc-tabs-0-tab-3"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-4" aria-labelledby="rc-tabs-0-tab-4"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-5" aria-labelledby="rc-tabs-0-tab-5"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-6" aria-labelledby="rc-tabs-0-tab-6"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-7" aria-labelledby="rc-tabs-0-tab-7"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-8" aria-labelledby="rc-tabs-0-tab-8"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-9" aria-labelledby="rc-tabs-0-tab-9"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-10" aria-labelledby="rc-tabs-0-tab-10"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-11" aria-labelledby="rc-tabs-0-tab-11"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-12" aria-labelledby="rc-tabs-0-tab-12"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-13" aria-labelledby="rc-tabs-0-tab-13"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-14" aria-labelledby="rc-tabs-0-tab-14"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-15" aria-labelledby="rc-tabs-0-tab-15"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-16" aria-labelledby="rc-tabs-0-tab-16"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-17" aria-labelledby="rc-tabs-0-tab-17"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-18" aria-labelledby="rc-tabs-0-tab-18"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-19" aria-labelledby="rc-tabs-0-tab-19"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-20" aria-labelledby="rc-tabs-0-tab-20"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-21" aria-labelledby="rc-tabs-0-tab-21"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-22" aria-labelledby="rc-tabs-0-tab-22"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-23" aria-labelledby="rc-tabs-0-tab-23"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-24" aria-labelledby="rc-tabs-0-tab-24"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-25" aria-labelledby="rc-tabs-0-tab-25"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-26" aria-labelledby="rc-tabs-0-tab-26"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-27" aria-labelledby="rc-tabs-0-tab-27"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-28" aria-labelledby="rc-tabs-0-tab-28"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-29" aria-labelledby="rc-tabs-0-tab-29"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-30" aria-labelledby="rc-tabs-0-tab-30"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-31" aria-labelledby="rc-tabs-0-tab-31"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-32" aria-labelledby="rc-tabs-0-tab-32"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-33" aria-labelledby="rc-tabs-0-tab-33"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-34" aria-labelledby="rc-tabs-0-tab-34"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-35" aria-labelledby="rc-tabs-0-tab-35"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-36" aria-labelledby="rc-tabs-0-tab-36"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-37" aria-labelledby="rc-tabs-0-tab-37"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-38" aria-labelledby="rc-tabs-0-tab-38"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-39" aria-labelledby="rc-tabs-0-tab-39"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-40" aria-labelledby="rc-tabs-0-tab-40"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-41" aria-labelledby="rc-tabs-0-tab-41"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-42" aria-labelledby="rc-tabs-0-tab-42"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-43" aria-labelledby="rc-tabs-0-tab-43"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-44" aria-labelledby="rc-tabs-0-tab-44"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-45" aria-labelledby="rc-tabs-0-tab-45"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-46" aria-labelledby="rc-tabs-0-tab-46"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-47" aria-labelledby="rc-tabs-0-tab-47"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-48" aria-labelledby="rc-tabs-0-tab-48"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-49" aria-labelledby="rc-tabs-0-tab-49"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-50" aria-labelledby="rc-tabs-0-tab-50"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-51" aria-labelledby="rc-tabs-0-tab-51"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-52" aria-labelledby="rc-tabs-0-tab-52"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-53" aria-labelledby="rc-tabs-0-tab-53"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-54" aria-labelledby="rc-tabs-0-tab-54"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-55" aria-labelledby="rc-tabs-0-tab-55"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-56" aria-labelledby="rc-tabs-0-tab-56"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-57" aria-labelledby="rc-tabs-0-tab-57"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-58" aria-labelledby="rc-tabs-0-tab-58"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-59" aria-labelledby="rc-tabs-0-tab-59"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-60" aria-labelledby="rc-tabs-0-tab-60"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-61" aria-labelledby="rc-tabs-0-tab-61"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-62" aria-labelledby="rc-tabs-0-tab-62"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-63" aria-labelledby="rc-tabs-0-tab-63"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-64" aria-labelledby="rc-tabs-0-tab-64"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-65" aria-labelledby="rc-tabs-0-tab-65"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-66" aria-labelledby="rc-tabs-0-tab-66"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-67" aria-labelledby="rc-tabs-0-tab-67"></div>
                  <div role="tabpanel" tabindex="-1" aria-hidden="true" className="ant-tabs-tabpane" style={{ display: "none" }} id="rc-tabs-0-panel-68" aria-labelledby="rc-tabs-0-tab-68"></div>
                </div>
              </div>
            </div>
            <div className="ant-spin-nested-loading">
              <div className="ant-spin-container">
                <div className="ant-list ant-list-split">
                  <div className="ant-spin-nested-loading">
                    <div className="ant-spin-container">
                      <ul className="ant-list-items">
                        <li className="ant-list-item">
                          <div className="mr-4">
                            <h4 className="ant-typography">1</h4>
                          </div>
                          <div className="ant-list-item-meta">
                            <div className="ant-list-item-meta-avatar"><span className="ant-avatar ant-avatar-circle ant-avatar-image" style={{ width: "44px", height: "44px", lineHeight: "44px", fontSize: "18px" }}><img
                              src="https://i.postimg.cc/fT5My4tY/Untitled-2.jpg" /></span>
                            </div>
                            <div className="ant-list-item-meta-content">
                              <h4 className="ant-list-item-meta-title">
                                <div><span>Metamic E-Sports Games</span><span className="ml-2 is-size-7">MEG</span></div>
                              </h4>
                              <div className="ant-list-item-meta-description">
                                <div className="flex items-center">
                                  <p><span> </span><a>930.3018424290229
                                    BNB</a></p>
                                  <p>&nbsp;–&nbsp;</p>
                                  <p><span>Listing time: </span><a>2022.11.15
                                    13:02</a></p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mr-2">
                            <div className="flex-wrapper">
                              <div className="single-chart"><svg viewBox="0 0 36 36" className="circular-chart green">
                                <path className="circle-bg"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path>
                                <path className="circle"
                                  stroke-dasharray="100, 100"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path><text x="18" y="20.35"
                                  className="percentage">100%</text>
                              </svg></div>
                            </div>
                          </div><a href="/launchpad/0xe6e57164626013754CB5aB620223cA6f3b5A1888?chain=BSC"><button
                            type="button"
                            className="ant-btn ant-btn-primary"><span>View
                              pool</span></button></a>
                        </li>
                        <li className="ant-list-item">
                          <div className="mr-4">
                            <h4 className="ant-typography">2</h4>
                          </div>
                          <div className="ant-list-item-meta">
                            <div className="ant-list-item-meta-avatar"><span className="ant-avatar ant-avatar-circle ant-avatar-image" style={{ width: "44px", height: "44px", lineHeight: "44px", fontSize: "18px" }}><img
                              src="https://photos.pinksale.finance/file/pinksale-logo-upload/1668289745592-1761de3352d18569abea28d5908d90e9.png" /></span>
                            </div>
                            <div className="ant-list-item-meta-content">
                              <h4 className="ant-list-item-meta-title">
                                <div><span>Moviex</span><span className="ml-2 is-size-7">MVX</span></div>
                              </h4>
                              <div className="ant-list-item-meta-description">
                                <div className="flex items-center">
                                  <p><span> </span><a>479.12229117919264
                                    BNB</a></p>
                                  <p>&nbsp;–&nbsp;</p>
                                  <p><span>Listing time: </span><a>2022.11.16
                                    16:59</a></p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mr-2">
                            <div className="flex-wrapper">
                              <div className="single-chart"><svg viewBox="0 0 36 36" className="circular-chart green">
                                <path className="circle-bg"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path>
                                <path className="circle"
                                  stroke-dasharray="100, 100"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path><text x="18" y="20.35"
                                  className="percentage">100%</text>
                              </svg></div>
                            </div>
                          </div><a href="/launchpad/0x017C51936fB4Dc54E692Ea823c32713006ADe25A?chain=BSC"><button
                            type="button"
                            className="ant-btn ant-btn-primary"><span>View
                              pool</span></button></a>
                        </li>
                        <li className="ant-list-item">
                          <div className="mr-4">
                            <h4 className="ant-typography">3</h4>
                          </div>
                          <div className="ant-list-item-meta">
                            <div className="ant-list-item-meta-avatar"><span className="ant-avatar ant-avatar-circle ant-avatar-image" style={{ width: "44px", height: "44px", lineHeight: "44px", fontSize: "18px" }}><img
                              src="https://88token.io/_next/static/media/logo.468ae8e3.svg" /></span>
                            </div>
                            <div className="ant-list-item-meta-content">
                              <h4 className="ant-list-item-meta-title">
                                <div><span>88 Token</span><span className="ml-2 is-size-7">88T</span></div>
                              </h4>
                              <div className="ant-list-item-meta-description">
                                <div className="flex items-center">
                                  <p><span> </span><a>370.1961168348692
                                    BNB</a></p>
                                  <p>&nbsp;–&nbsp;</p>
                                  <p><span>Listing time: </span><a>2022.11.14
                                    10:24</a></p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mr-2">
                            <div className="flex-wrapper">
                              <div className="single-chart"><svg viewBox="0 0 36 36" className="circular-chart green">
                                <path className="circle-bg"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path>
                                <path className="circle"
                                  stroke-dasharray="99.99999999999999, 100"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path><text x="18" y="20.35"
                                  className="percentage">100.0%</text>
                              </svg></div>
                            </div>
                          </div><a href="/launchpad/0x5E04C865C34166fCFBAd2a22E3f07bD597c37BaA?chain=BSC"><button
                            type="button"
                            className="ant-btn ant-btn-primary"><span>View
                              pool</span></button></a>
                        </li>
                        <li className="ant-list-item">
                          <div className="mr-4">
                            <h4 className="ant-typography">4</h4>
                          </div>
                          <div className="ant-list-item-meta">
                            <div className="ant-list-item-meta-avatar"><span className="ant-avatar ant-avatar-circle ant-avatar-image" style={{ width: "44px", height: "44px", lineHeight: "44px", fontSize: "18px" }}><img
                              src="https://photos.pinksale.finance/file/pinksale-logo-upload/1667916050830-80767826112168a64f748d1d0b015282.jpg" /></span>
                            </div>
                            <div className="ant-list-item-meta-content">
                              <h4 className="ant-list-item-meta-title">
                                <div><span>DomeChain</span><span className="ml-2 is-size-7">DC</span></div>
                              </h4>
                              <div className="ant-list-item-meta-description">
                                <div className="flex items-center">
                                  <p><span> </span><a>300 BNB</a></p>
                                  <p>&nbsp;–&nbsp;</p>
                                  <p><span>Listing time: </span><a>2022.11.15
                                    13:00</a></p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mr-2">
                            <div className="flex-wrapper">
                              <div className="single-chart"><svg viewBox="0 0 36 36" className="circular-chart green">
                                <path className="circle-bg"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path>
                                <path className="circle"
                                  stroke-dasharray="100, 100"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path><text x="18" y="20.35"
                                  className="percentage">100%</text>
                              </svg></div>
                            </div>
                          </div><a href="/launchpad/0x138242D3F1f67B18579197C4274159fA1586101d?chain=BSC"><button
                            type="button"
                            className="ant-btn ant-btn-primary"><span>View
                              pool</span></button></a>
                        </li>
                        <li className="ant-list-item">
                          <div className="mr-4">
                            <h4 className="ant-typography">5</h4>
                          </div>
                          <div className="ant-list-item-meta">
                            <div className="ant-list-item-meta-avatar"><span className="ant-avatar ant-avatar-circle ant-avatar-image" style={{ width: "44px", height: "44px", lineHeight: "44px", fontSize: "18px" }}><img
                              src="https://photos.pinksale.finance/file/pinksale-logo-upload/1668345103114-ff46ece00da94d6e8c08eeae33b212a1.png" /></span>
                            </div>
                            <div className="ant-list-item-meta-content">
                              <h4 className="ant-list-item-meta-title">
                                <div><span>Griffin Art Ecosystem</span><span className="ml-2 is-size-7">GART</span></div>
                              </h4>
                              <div className="ant-list-item-meta-description">
                                <div className="flex items-center">
                                  <p><span> </span><a>248.90797814878152
                                    BNB</a></p>
                                  <p>&nbsp;–&nbsp;</p>
                                  <p><span>Listing time: </span><a>2022.11.16
                                    14:00</a></p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mr-2">
                            <div className="flex-wrapper">
                              <div className="single-chart"><svg viewBox="0 0 36 36" className="circular-chart green">
                                <path className="circle-bg"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path>
                                <path className="circle"
                                  stroke-dasharray="62.22699453719538, 100"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path><text x="18" y="20.35"
                                  className="percentage">62.2%</text>
                              </svg></div>
                            </div>
                          </div><a href="/launchpad/0x4E6f51dADc271B126d314231d7FB5FBF023624F4?chain=BSC"><button
                            type="button"
                            className="ant-btn ant-btn-primary"><span>View
                              pool</span></button></a>
                        </li>
                        <li className="ant-list-item">
                          <div className="mr-4">
                            <h4 className="ant-typography">6</h4>
                          </div>
                          <div className="ant-list-item-meta">
                            <div className="ant-list-item-meta-avatar"><span className="ant-avatar ant-avatar-circle ant-avatar-image" style={{ width: "44px", height: "44px", lineHeight: "44px", fontSize: "18px" }}><img
                              src="https://photos.pinksale.finance/file/pinksale-logo-upload/1665113144891-a70993a49308d167b89c974dbb128a11.jpg" /></span>
                            </div>
                            <div className="ant-list-item-meta-content">
                              <h4 className="ant-list-item-meta-title">
                                <div><span>Crypto Soccer</span><span className="ml-2 is-size-7">$CRS</span></div>
                              </h4>
                              <div className="ant-list-item-meta-description">
                                <div className="flex items-center">
                                  <p><span> </span><a>240 BNB</a></p>
                                  <p>&nbsp;–&nbsp;</p>
                                  <p><span>Listing time: </span><a>2022.11.16
                                    15:03</a></p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mr-2">
                            <div className="flex-wrapper">
                              <div className="single-chart"><svg viewBox="0 0 36 36" className="circular-chart green">
                                <path className="circle-bg"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path>
                                <path className="circle"
                                  stroke-dasharray="100, 100"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path><text x="18" y="20.35"
                                  className="percentage">100%</text>
                              </svg></div>
                            </div>
                          </div><a href="/launchpad/0x9A681212140C4c091Da430eFCDC567BF7849960F?chain=BSC"><button
                            type="button"
                            className="ant-btn ant-btn-primary"><span>View
                              pool</span></button></a>
                        </li>
                        <li className="ant-list-item">
                          <div className="mr-4">
                            <h4 className="ant-typography">7</h4>
                          </div>
                          <div className="ant-list-item-meta">
                            <div className="ant-list-item-meta-avatar"><span className="ant-avatar ant-avatar-circle ant-avatar-image" style={{ width: "44px", height: "44px", lineHeight: "44px", fontSize: "18px" }}><img
                              src="https://assets.website-files.com/633032b9220f2d1eca2431b9/6331068ce2391240f9e456d0_white%20-%20webclip.png" /></span>
                            </div>
                            <div className="ant-list-item-meta-content">
                              <h4 className="ant-list-item-meta-title">
                                <div><span>JIYU NETWORK</span><span className="ml-2 is-size-7">JIYU</span></div>
                              </h4>
                              <div className="ant-list-item-meta-description">
                                <div className="flex items-center">
                                  <p><span> </span><a>155.79267078061386
                                    BNB</a></p>
                                  <p>&nbsp;–&nbsp;</p>
                                  <p><span>Listing time: </span><a>2022.11.16
                                    04:06</a></p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mr-2">
                            <div className="flex-wrapper">
                              <div className="single-chart"><svg viewBox="0 0 36 36" className="circular-chart green">
                                <path className="circle-bg"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path>
                                <path className="circle"
                                  stroke-dasharray="100, 100"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path><text x="18" y="20.35"
                                  className="percentage">100%</text>
                              </svg></div>
                            </div>
                          </div><a href="/launchpad/0x123F91430f1196e75A510966b6d81675cCa33eB7?chain=BSC"><button
                            type="button"
                            className="ant-btn ant-btn-primary"><span>View
                              pool</span></button></a>
                        </li>
                        <li className="ant-list-item">
                          <div className="mr-4">
                            <h4 className="ant-typography">8</h4>
                          </div>
                          <div className="ant-list-item-meta">
                            <div className="ant-list-item-meta-avatar"><span className="ant-avatar ant-avatar-circle ant-avatar-image" style={{ width: "44px", height: "44px", lineHeight: "44px", fontSize: "18px" }}><img
                              src="https://i.imgur.com/9Vrpqcp.png" /></span>
                            </div>
                            <div className="ant-list-item-meta-content">
                              <h4 className="ant-list-item-meta-title">
                                <div><span>Pure Wallet</span><span className="ml-2 is-size-7">PURE</span></div>
                              </h4>
                              <div className="ant-list-item-meta-description">
                                <div className="flex items-center">
                                  <p><span> </span><a>147.88297092986818
                                    BNB</a></p>
                                  <p>&nbsp;–&nbsp;</p>
                                  <p><span>Listing time: </span><a>2022.11.16
                                    19:15</a></p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mr-2">
                            <div className="flex-wrapper">
                              <div className="single-chart"><svg viewBox="0 0 36 36" className="circular-chart green">
                                <path className="circle-bg"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path>
                                <path className="circle"
                                  stroke-dasharray="100, 100"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path><text x="18" y="20.35"
                                  className="percentage">100%</text>
                              </svg></div>
                            </div>
                          </div><a href="/launchpad/0x2a34040aea4587312b209ecD88507E0b4A832266?chain=BSC"><button
                            type="button"
                            className="ant-btn ant-btn-primary"><span>View
                              pool</span></button></a>
                        </li>
                        <li className="ant-list-item">
                          <div className="mr-4">
                            <h4 className="ant-typography">9</h4>
                          </div>
                          <div className="ant-list-item-meta">
                            <div className="ant-list-item-meta-avatar"><span className="ant-avatar ant-avatar-circle ant-avatar-image" style={{ width: "44px", height: "44px", lineHeight: "44px", fontSize: "18px" }}><img
                              src="https://photos.pinksale.finance/file/pinksale-logo-upload/1668018438320-1bb87d41d15fe27b500a4bfcde01bb0e.png" /></span>
                            </div>
                            <div className="ant-list-item-meta-content">
                              <h4 className="ant-list-item-meta-title">
                                <div><span>Xrp Classic</span><span className="ml-2 is-size-7">XRPC</span></div>
                              </h4>
                              <div className="ant-list-item-meta-description">
                                <div className="flex items-center">
                                  <p><span> </span><a>121.10630720728892
                                    BNB</a></p>
                                  <p>&nbsp;–&nbsp;</p>
                                  <p><span>Listing time: </span><a>2022.11.14
                                    18:18</a></p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mr-2">
                            <div className="flex-wrapper">
                              <div className="single-chart"><svg viewBox="0 0 36 36" className="circular-chart green">
                                <path className="circle-bg"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path>
                                <path className="circle"
                                  stroke-dasharray="100, 100"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path><text x="18" y="20.35"
                                  className="percentage">100%</text>
                              </svg></div>
                            </div>
                          </div><a href="/launchpad/0x90fb7AFe94d1572ec47835d14AD7fbE0CB8Ef875?chain=BSC"><button
                            type="button"
                            className="ant-btn ant-btn-primary"><span>View
                              pool</span></button></a>
                        </li>
                        <li className="ant-list-item">
                          <div className="mr-4">
                            <h4 className="ant-typography">10</h4>
                          </div>
                          <div className="ant-list-item-meta">
                            <div className="ant-list-item-meta-avatar"><span className="ant-avatar ant-avatar-circle ant-avatar-image" style={{ width: "44px", height: "44px", lineHeight: "44px", fontSize: "18px" }}><img
                              src="https://photos.pinksale.finance/file/pinksale-logo-upload/1668352245165-89341455f364342f4fad97382b8d923f.png" /></span>
                            </div>
                            <div className="ant-list-item-meta-content">
                              <h4 className="ant-list-item-meta-title">
                                <div><span>SuperfootballCoin</span><span className="ml-2 is-size-7">SFC</span></div>
                              </h4>
                              <div className="ant-list-item-meta-description">
                                <div className="flex items-center">
                                  <p><span> </span><a>120 BNB</a></p>
                                  <p>&nbsp;–&nbsp;</p>
                                  <p><span>Listing time: </span><a>2022.11.14
                                    12:28</a></p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mr-2">
                            <div className="flex-wrapper">
                              <div className="single-chart"><svg viewBox="0 0 36 36" className="circular-chart green">
                                <path className="circle-bg"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path>
                                <path className="circle"
                                  stroke-dasharray="100, 100"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path><text x="18" y="20.35"
                                  className="percentage">100%</text>
                              </svg></div>
                            </div>
                          </div><a href="/launchpad/0x78a1102b4c22F66dEcEcA01F0e133CdCA814b52A?chain=BSC"><button
                            type="button"
                            className="ant-btn ant-btn-primary"><span>View
                              pool</span></button></a>
                        </li>
                        <li className="ant-list-item">
                          <div className="mr-4">
                            <h4 className="ant-typography">11</h4>
                          </div>
                          <div className="ant-list-item-meta">
                            <div className="ant-list-item-meta-avatar"><span className="ant-avatar ant-avatar-circle ant-avatar-image" style={{ width: "44px", height: "44px", lineHeight: "44px", fontSize: "18px" }}><img
                              src="https://photos.pinksale.finance/file/pinksale-logo-upload/1668612075811-fb7ee040cd523b5490e41a8e385dfad7.jpg" /></span>
                            </div>
                            <div className="ant-list-item-meta-content">
                              <h4 className="ant-list-item-meta-title">
                                <div><span>PI Network Chain</span><span className="ml-2 is-size-7">PC</span></div>
                              </h4>
                              <div className="ant-list-item-meta-description">
                                <div className="flex items-center">
                                  <p><span> </span><a>120 BNB</a></p>
                                  <p>&nbsp;–&nbsp;</p>
                                  <p><span>Listing time: </span><a>2022.11.17
                                    13:16</a></p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mr-2">
                            <div className="flex-wrapper">
                              <div className="single-chart"><svg viewBox="0 0 36 36" className="circular-chart green">
                                <path className="circle-bg"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path>
                                <path className="circle"
                                  stroke-dasharray="100, 100"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path><text x="18" y="20.35"
                                  className="percentage">100%</text>
                              </svg></div>
                            </div>
                          </div><a href="/launchpad/0x2E0B9F806647fDd097EF451bCAfCf508de182730?chain=BSC"><button
                            type="button"
                            className="ant-btn ant-btn-primary"><span>View
                              pool</span></button></a>
                        </li>
                        <li className="ant-list-item">
                          <div className="mr-4">
                            <h4 className="ant-typography">12</h4>
                          </div>
                          <div className="ant-list-item-meta">
                            <div className="ant-list-item-meta-avatar"><span className="ant-avatar ant-avatar-circle ant-avatar-image" style={{ width: "44px", height: "44px", lineHeight: "44px", fontSize: "18px" }}><img
                              src="https://photos.pinksale.finance/file/pinksale-logo-upload/1668559380010-9952b6d404f8df0dceaab25e290367ef.jpg" /></span>
                            </div>
                            <div className="ant-list-item-meta-content">
                              <h4 className="ant-list-item-meta-title">
                                <div><span>MonsterVsMonster</span><span className="ml-2 is-size-7">MVSM</span></div>
                              </h4>
                              <div className="ant-list-item-meta-description">
                                <div className="flex items-center">
                                  <p><span> </span><a>111.8074944139681
                                    BNB</a></p>
                                  <p>&nbsp;–&nbsp;</p>
                                  <p><span>Listing time: </span><a>2022.11.16
                                    03:35</a></p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mr-2">
                            <div className="flex-wrapper">
                              <div className="single-chart"><svg viewBox="0 0 36 36" className="circular-chart green">
                                <path className="circle-bg"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path>
                                <path className="circle"
                                  stroke-dasharray="100, 100"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path><text x="18" y="20.35"
                                  className="percentage">100%</text>
                              </svg></div>
                            </div>
                          </div><a href="/launchpad/0x0C208b550296Bc29cD79d2b28eFb82a764E602E4?chain=BSC"><button
                            type="button"
                            className="ant-btn ant-btn-primary"><span>View
                              pool</span></button></a>
                        </li>
                        <li className="ant-list-item">
                          <div className="mr-4">
                            <h4 className="ant-typography">13</h4>
                          </div>
                          <div className="ant-list-item-meta">
                            <div className="ant-list-item-meta-avatar"><span className="ant-avatar ant-avatar-circle ant-avatar-image" style={{ width: "44px", height: "44px", lineHeight: "44px", fontSize: "18px" }}><img
                              src="https://photos.pinksale.finance/file/pinksale-logo-upload/1668344047540-f3ccdd27d2000e3f9255a7e3e2c48800.jpg" /></span>
                            </div>
                            <div className="ant-list-item-meta-content">
                              <h4 className="ant-list-item-meta-title">
                                <div><span>GOGA</span><span className="ml-2 is-size-7">$GGT</span></div>
                              </h4>
                              <div className="ant-list-item-meta-description">
                                <div className="flex items-center">
                                  <p><span> </span><a>97.23769103583115
                                    BNB</a></p>
                                  <p>&nbsp;–&nbsp;</p>
                                  <p><span>Listing time: </span><a>2022.11.14
                                    00:05</a></p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mr-2">
                            <div className="flex-wrapper">
                              <div className="single-chart"><svg viewBox="0 0 36 36" className="circular-chart green">
                                <path className="circle-bg"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path>
                                <path className="circle"
                                  stroke-dasharray="99.99999999999999, 100"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path><text x="18" y="20.35"
                                  className="percentage">100.0%</text>
                              </svg></div>
                            </div>
                          </div><a href="/launchpad/0xfC0fC5E3a6497c5E9fb3441058417D0a69419879?chain=BSC"><button
                            type="button"
                            className="ant-btn ant-btn-primary"><span>View
                              pool</span></button></a>
                        </li>
                        <li className="ant-list-item">
                          <div className="mr-4">
                            <h4 className="ant-typography">14</h4>
                          </div>
                          <div className="ant-list-item-meta">
                            <div className="ant-list-item-meta-avatar"><span className="ant-avatar ant-avatar-circle ant-avatar-image" style={{ width: "44px", height: "44px", lineHeight: "44px", fontSize: "18px" }}><img
                              src="https://photos.pinksale.finance/file/pinksale-logo-upload/1667041830378-05f1cba0d2b9cad4c01e85511f312058.png" /></span>
                            </div>
                            <div className="ant-list-item-meta-content">
                              <h4 className="ant-list-item-meta-title">
                                <div><span>RealMoneyWorld</span><span className="ml-2 is-size-7">RMW</span></div>
                              </h4>
                              <div className="ant-list-item-meta-description">
                                <div className="flex items-center">
                                  <p><span> </span><a>50 BNB</a></p>
                                  <p>&nbsp;–&nbsp;</p>
                                  <p><span>Listing time: </span><a>2022.11.17
                                    08:50</a></p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mr-2">
                            <div className="flex-wrapper">
                              <div className="single-chart"><svg viewBox="0 0 36 36" className="circular-chart green">
                                <path className="circle-bg"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path>
                                <path className="circle"
                                  stroke-dasharray="100, 100"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path><text x="18" y="20.35"
                                  className="percentage">100%</text>
                              </svg></div>
                            </div>
                          </div><a href="/launchpad/0xEb3520e7B611909D70003336D27328D6010EE676?chain=BSC"><button
                            type="button"
                            className="ant-btn ant-btn-primary"><span>View
                              pool</span></button></a>
                        </li>
                        <li className="ant-list-item">
                          <div className="mr-4">
                            <h4 className="ant-typography">15</h4>
                          </div>
                          <div className="ant-list-item-meta">
                            <div className="ant-list-item-meta-avatar"><span className="ant-avatar ant-avatar-circle ant-avatar-image" style={{ width: "44px", height: "44px", lineHeight: "44px", fontSize: "18px" }}><img
                              src="https://photos.pinksale.finance/file/pinksale-logo-upload/1668431446034-8c77d3f74dabf9f2a72a538e62543b76.jpg" /></span>
                            </div>
                            <div className="ant-list-item-meta-content">
                              <h4 className="ant-list-item-meta-title">
                                <div><span>Phenas Token</span><span className="ml-2 is-size-7">Phenas</span>
                                </div>
                              </h4>
                              <div className="ant-list-item-meta-description">
                                <div className="flex items-center">
                                  <p><span> </span><a>43.28075128874288
                                    BNB</a></p>
                                  <p>&nbsp;–&nbsp;</p>
                                  <p><span>Listing time: </span><a>2022.11.16
                                    11:06</a></p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mr-2">
                            <div className="flex-wrapper">
                              <div className="single-chart"><svg viewBox="0 0 36 36" className="circular-chart green">
                                <path className="circle-bg"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path>
                                <path className="circle"
                                  stroke-dasharray="86.56150257748575, 100"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path><text x="18" y="20.35"
                                  className="percentage">86.6%</text>
                              </svg></div>
                            </div>
                          </div><a href="/launchpad/0xDB8224cb155659485dfE6AF787F5E0C169F36Be4?chain=BSC"><button
                            type="button"
                            className="ant-btn ant-btn-primary"><span>View
                              pool</span></button></a>
                        </li>
                        <li className="ant-list-item">
                          <div className="mr-4">
                            <h4 className="ant-typography">16</h4>
                          </div>
                          <div className="ant-list-item-meta">
                            <div className="ant-list-item-meta-avatar"><span className="ant-avatar ant-avatar-circle ant-avatar-image" style={{ width: "44px", height: "44px", lineHeight: "44px", fontSize: "18px" }}><img
                              src="https://photos.pinksale.finance/file/pinksale-logo-upload/1668202508601-82648404805d1e59db269c59d411fc4f.png" /></span>
                            </div>
                            <div className="ant-list-item-meta-content">
                              <h4 className="ant-list-item-meta-title">
                                <div><span>Baby EZ Doge</span><span className="ml-2 is-size-7">BEZDOGE</span>
                                </div>
                              </h4>
                              <div className="ant-list-item-meta-description">
                                <div className="flex items-center">
                                  <p><span> </span><a>41.86418753883603
                                    BNB</a></p>
                                  <p>&nbsp;–&nbsp;</p>
                                  <p><span>Listing time: </span><a>2022.11.14
                                    16:00</a></p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mr-2">
                            <div className="flex-wrapper">
                              <div className="single-chart"><svg viewBox="0 0 36 36" className="circular-chart green">
                                <path className="circle-bg"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path>
                                <path className="circle"
                                  stroke-dasharray="100.00000000000001, 100"
                                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
                                </path><text x="18" y="20.35"
                                  className="percentage">100.0%</text>
                              </svg></div>
                            </div>
                          </div><a href="/launchpad/0xFE16E39DfEAb4DEB9575732b0D7e7559294b33C2?chain=BSC"><button
                            type="button"
                            className="ant-btn ant-btn-primary"><span>View
                              pool</span></button></a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}
const mapStateToProps = (state) =>
{
  return {

  };
};
const mapDispatchToProps = (dispatch, props) =>
{
  return {
    // GetConvertion: (idpage) =>
    // {
    //   dispatch(Actions.GetConvertionRequest(idpage));
    // },
    // Getprovince: () =>
    // {
    //   dispatch(Actions.GetprovinceRequest());
    // },
    // GetComment: (idpage) =>
    // {
    //   dispatch(Actions.GetCommentRequest(idpage));
    // },
    // GetPageList: (data) =>
    // {
    //   dispatch(Actions.GetPageListRequest(data));
    // },
    // SetPageLocal: (data) =>
    // {
    //   dispatch(Actions.SetPageLocal(data));
    // },
    // GetSetting: () =>
    // {
    //   dispatch(Actions.GetSettingRequest());
    // },
    // GetSuportReply: () =>
    // {
    //   dispatch(Actions.GetSuportReplyRequest());
    // },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
